<form nz-form class="form" nzLayout="horizontal" [formGroup]="organizationForm">
  <div class="drawer-form-wrapper">
    <app-search-select
      label="Search Organization"
      inputId="orgSelect"
      [control]="organizationForm.get('orgparentorg')"
      lookupType="ParentOrganization"
      placeholder="Search"
      noDataText="No organizations found"
      requiredErrorMessage="Please select a Parent Organization">
    </app-search-select>

    <ng-container *ngIf="sftpStatus$ | async as sftpStatus">
      <div
        class="sftp-status-wrapper"
        *ngIf="organizationForm.get('orgparentorg')?.value">
        <nz-alert
          *ngIf="sftpStatus.isChecking"
          nzType="info"
          nzMessage="Checking SFTP configuration..."
          nzShowIcon>
        </nz-alert>

        <nz-alert
          *ngIf="
            !sftpStatus.isChecking &&
            !sftpStatus.isSftpEnabled &&
            sftpStatus.errorMessage
          "
          nzType="error"
          [nzMessage]="sftpStatus.errorMessage"
          nzShowIcon>
        </nz-alert>

        <nz-alert
          *ngIf="!sftpStatus.isChecking && sftpStatus.isSftpEnabled"
          nzType="success"
          nzMessage="SFTP is configured for this organization."
          nzShowIcon>
        </nz-alert>
      </div>
    </ng-container>

    <div class="btn-wrapper-end">
      <button
        type="button"
        nz-button
        nzType="primary"
        [disabled]="isImportButtonDisabled"
        [nzLoading]="(isLoading$ | async) || (sftpStatus$ | async)?.isChecking"
        (click)="importFile()">
        Trigger SFTP Upload
      </button>
    </div>
    <div class="drawer-footer">
      <button nz-button nzType="default" (click)="closeDrawer()">Cancel</button>
    </div>
  </div>
</form>
